import type { MarkerDefinition, MarkerId } from './types.ts';

export const markerLookup = {
	'attention.available': {
		id: 'attention.available',
		family: 'attention',
		symbol: '!',
		wowColor: 'yellow',
		label: 'Available',
		plainText: '! available',
		ttyText: '\u001B[33m!\u001B[39m',
		htmlClass: 'questlog-marker--attention-available',
	},
	'attention.available.repeatable': {
		id: 'attention.available.repeatable',
		family: 'attention',
		symbol: '!',
		wowColor: 'blue',
		label: 'Repeatable available',
		plainText: '! repeatable',
		ttyText: '\u001B[34m!\u001B[39m',
		htmlClass: 'questlog-marker--attention-available-repeatable',
	},
	'attention.available.future': {
		id: 'attention.available.future',
		family: 'attention',
		symbol: '!',
		wowColor: 'gray',
		label: 'Future available',
		plainText: '! future',
		ttyText: '\u001B[90m!\u001B[39m',
		htmlClass: 'questlog-marker--attention-available-future',
	},
	'progress.incomplete': {
		id: 'progress.incomplete',
		family: 'progress',
		symbol: '?',
		wowColor: 'gray',
		label: 'Incomplete',
		plainText: '? incomplete',
		ttyText: '\u001B[90m?\u001B[39m',
		htmlClass: 'questlog-marker--progress-incomplete',
	},
	'progress.complete': {
		id: 'progress.complete',
		family: 'progress',
		symbol: '?',
		wowColor: 'yellow',
		label: 'Turn-in pending',
		plainText: '? turn-in pending',
		ttyText: '\u001B[33m?\u001B[39m',
		htmlClass: 'questlog-marker--progress-complete',
	},
} satisfies Record<MarkerId, MarkerDefinition>;
